// extracted by mini-css-extract-plugin
export default {"grid":"documents_grid__aaPo5","accentTitle":"documents_accentTitle__bAPjL"};